import type React from "react";
import { useEffect, useState } from "react";
import "./ConsentBanner.css";

export const ConsentBanner: React.FC = () => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const consent = localStorage.getItem("adafia-consent");
		if (!consent) {
			setIsVisible(true);
		}
	}, []);

	const handleAccept = () => {
		localStorage.setItem("adafia-consent", "granted");
		window.dispatchEvent(new Event("adafia-consent-granted"));
		setIsVisible(false);
	};

	const handleDecline = () => {
		localStorage.setItem("adafia-consent", "denied");
		setIsVisible(false);
	};

	if (!isVisible) return null;

	return (
		<div className="consent-banner">
			<div className="consent-content">
				<div className="consent-text">
					<h4>Privacy & Diagnostics</h4>
					<p>
						I use secure telemetry to analyze performance, page views, and
						location metrics. This helps me optimize the portfolio experience.
					</p>
				</div>
				<div className="consent-actions">
					<button
						type="button"
						onClick={handleDecline}
						className="consent-btn consent-btn-decline"
					>
						Decline
					</button>
					<button
						type="button"
						onClick={handleAccept}
						className="consent-btn consent-btn-accept"
					>
						Allow
					</button>
				</div>
			</div>
		</div>
	);
};
